export default __webpack_public_path__ + "static/techbureau_oneline-23556c6e66e0b27127c993655002ca16.png";